/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MathFunctionOffIcon32Regular = forwardRef('MathFunctionOffIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M4.945 3.293a1 1 0 0 0-1.414 1.414l24 24a1 1 0 0 0 1.414-1.414l-5.734-5.734 3.298-3.298a1 1 0 0 0-1.414-1.414l-3.298 3.297L15.652 14h1.339a1 1 0 1 0 0-2h-3.338l-1.403-1.402V10.5a4.5 4.5 0 0 1 4.5-4.5h1a1 1 0 1 0 0-2h-1a6.503 6.503 0 0 0-6.28 4.817L4.945 3.293Z" }),
        React.createElement("path", { d: "M6.505 12h1.342l2 2H6.505a1 1 0 1 1 0-2Z" }),
        React.createElement("path", { d: "M10.25 20.5v-6.097l2 2V20.5a6.5 6.5 0 0 1-6.5 6.5h-.5a1 1 0 1 1 0-2h.5a4.5 4.5 0 0 0 4.5-4.5Z" }),
        React.createElement("path", { d: "m16.677 25.265 2.217-2.218 1.415 1.414-2.218 2.218a1 1 0 0 1-1.415-1.414Z" })));
});
